export const SERVICES_STATE_TOKEN = 'SERVICES';

export const SERVICES_API_PATHS = {
    services: 'client/services'
};
